module.exports = __webpack_public_path__ + "img/t-shirt-icon-white.60f5370d.svg";